<div class="form_to_fill_content d-flex flex-column">
  <p [innerHTML]="'home.subscriptionFARPODQ' | translate"></p>
  @if (
    (memberStatus$ | async) && (periods$ | async)) {
    @if (userCanEditForm && hasSubscriptionFormEditable) {
      <div class="d-flex justify-content-center align-items-center"
        >
        <button
          mat-flat-button
          [routerLink]="['/', 'farp-subscription']"
          color="primary"
          class="home-fill-form-button">
          {{ "home.fillFormula" | translate }}
        </button>
      </div>
    }
    @if (
      (userCanEditForm || isExemptFromInsurance) &&
      !hasSubscriptionFormEditable
      ) {
      <div
        >
        @if (
          !(loadingPeriods$ | async) && (memberId$ | async)) {
          <div
            class="periodContainer d-flex justify-content-center align-items-center">
            @for (period of subscriptionPeriods; track period) {
              <mat-card
                appearance="outlined"
                class="home-farp-period-card">
                <mat-card-content>
                  <div>
                    @if (period?.isAnnual) {
                      <div>
                        <span class="periodCardTtitle">
                          {{
                          period?.editable
                          ? "Formulaire pour l'année:"
                          : "Documents pour l'année:"
                          }}
                          <br />
                          {{ period?.year }}</span
                          >
                        </div>
                      }
                      @if (!period?.isAnnual) {
                        <div>
                          <span class="periodCardTtitle"
                            >Avis de souscription: <br />
                            {{ period?.description }}</span
                            >
                          </div>
                        }
                        <div class="periodButtonsContainer">
                          @if (period?.editable) {
                            <div class="buttonDiv">
                              <button
                                mat-raised-button
                                color="primary"
                                (click)="fillForm(period)"
                                >
                                Remplir formulaire
                              </button>
                            </div>
                          }
                          @if (period?.hasParticularConditionsReport) {
                            <div
                              class="buttonDiv"
                              >
                              <button
                                title="Rapport de conditions particulières"
                                mat-raised-button
                      (click)="
                        showReportParticularConditions(period)
                      "
                                >
                                <mat-icon>summarize</mat-icon>
                                Conditions particulières
                              </button>
                            </div>
                          }
                          @if (period?.receipts?.length > 0) {
                            <div
                              class="buttonDiv"
                              >
                              <button
                                title="Reçus"
                                mat-raised-button
                                [matMenuTriggerFor]="menu"
                                >
                                <mat-icon>receipt_long</mat-icon>
                                {{ period?.receipts?.length }} Reçus
                              </button>
                              <mat-menu #menu="matMenu">
                                @for (r of period?.receipts; track r) {
                                  <button
                                    mat-menu-item
                                    (click)="showReceipt(r)"
                                    >
                                    <span>{{ r?.description }}</span>
                                  </button>
                                }
                              </mat-menu>
                            </div>
                          }
                        </div>
                      </div>
                    </mat-card-content>
                  </mat-card>
                }
              </div>
            } @else {
              <div class="loading-spinner">
                <mat-spinner diameter="100"></mat-spinner>
              </div>
            }
            @if (loadingReport$ | async) {
              <div
                class="spinner-container d-flex justify-content-center align-items-center"
                >
                <mat-spinner diameter="100"></mat-spinner>
              </div>
            }
          </div>
        }
        @if (!userCanEditForm && isExerciseStatus === false) {
          <div
            class="information_notice"
            >
            <p
              [innerHTML]="'home.exerciseStatusInactive' | translate"
            ></p>
          </div>
        }
        @if (!userCanEditForm && isInscriptionStatus === false) {
          <div
            class="information_notice"
            >
            <p
              [innerHTML]="'home.inscriptionStatusNoRegister' | translate"
            ></p>
          </div>
        }
        @if (
          isInscriptionStatus === true &&
          isExemptFromInsurance === true
          ) {
          <div
            class="information_notice"
            >
            <p
        [innerHTML]="
          'home.inscriptionStatusActifAndExempted' | translate
        "
            ></p>
          </div>
        }
      } @else {
        <div class="loading-spinner">
          <mat-spinner diameter="50"></mat-spinner>
        </div>
      }
    </div>
